<template>
  <div>
    <category-no-results
      v-show="freeSelected && freeIconCount == 0"
      :category-label="categoryLabel"
      :selected-style="selectedStyle"
      :selected-family="selectedFamily"
    />

    <div
      :id="`icon-results-${sluggifyStyle(selectedStyle)}`"
      class="compact icon-listing margin-top-lg margin-bottom-4xl"
      role="tabpanel"
      :aria-labelledby="`tab-${sluggifyStyle(selectedStyle)}`"
    >
      <icon
        v-for="item in icons"
        :key="item.objectID"
        :icon="item"
        :icon-style="item.style"
        :is-pro-user="isProUser"
        :new-tag-enabled="true"
        :selected-icon-id="selectedIconId"
        :selected-style="selectedStyle"
        :version="version"
        results-view="compact"
        @toggleIcon="toggleIcon"
      />
    </div>
  </div>
</template>

<script>
  import { createWidgetMixin } from 'vue-instantsearch'
  import { connectHits } from 'instantsearch.js/es/connectors'
  import sluggify from 'app/utils/sluggify'
  import Icon from '../icons/Icon'
  import CategoryNoResults from './CategoryNoResults'

  export default {
    name: 'CategoryIcons',

    components: {
      CategoryNoResults,
      Icon
    },

    mixins: [createWidgetMixin({ connector: connectHits })],

    props: {
      categoryLabel: {
        type: String
      },
      selectedStyle: {
        type: String
      },
      selectedFamily: {
        type: String
      },
      selectedIconId: {
        type: String
      },
      isProUser: {
        type: Boolean
      },
      freeSelected: {
        type: Boolean
      },
      version: {
        type: Number,
        default: null
      },
      searchFieldFocus: {
        type: Boolean,
        required: true
      }
    },

    data() {
      return {
        iconObjectId: null
      }
    },

    computed: {
      icons() {
        if (!this.state) return null

        if (this.freeSelected && this.freeIconCount > 0) {
          this.$posthog.capture('category_landing:free_icons_view', {
            category: this.categoryLabel,
            icon_family: this.selectedFamily,
            icon_style: this.selectedStyle,
            icon_count: this.freeIconCount
          })
          return this.state != null ? this.state.hits.filter((icon) => icon.is_free === true && icon.family == this.selectedFamily) : null
        } else {
          return this.state != null ? this.state.hits.filter((icon) => icon.family == this.selectedFamily) : null
        }
      },

      freeIconCount() {
        if (!this.state) return 0
        return this.state.hits.filter((icon) => icon.is_free === true && icon.family == this.selectedFamily).length
      }
    },

    created() {
      document.addEventListener('keydown', this.keydownEvent)
    },

    destroyed() {
      document.removeEventListener('keydown', this.keydownEvent)
    },

    methods: {
      keydownEvent(event) {
        if (event.isComposing) {
          return
        }
        if (!this.searchFieldFocus) {
          if (event.code == 'ArrowRight') {
            this.next()
          }

          if (event.code == 'ArrowLeft') {
            this.previous()
          }

          if (event.code == 'Escape') {
            this.closeIcon()
          }
        }
      },

      next() {
        if (this.state) {
          const nextIconIndex = this.getCurrentIconIndex() + 1

          if (nextIconIndex < this.state.hits.length) {
            const nextIcon = this.state.hits[nextIconIndex]
            this.iconObjectId = nextIcon.objectID
            this.$emit('toggleIcon', nextIcon, this.getIconId(nextIcon))
            this.scrollToIcon(this.getIconId(nextIcon))
          }
        }
      },

      previous() {
        if (this.state) {
          const previousIconIndex = this.getCurrentIconIndex() - 1

          if (previousIconIndex >= 0) {
            const previousIcon = this.state.hits[previousIconIndex]
            this.iconObjectId = previousIcon.objectID
            this.$emit('toggleIcon', previousIcon, this.getIconId(previousIcon))
            this.scrollToIcon(this.getIconId(previousIcon))
          }
        }
      },

      getIconId(icon) {
        return `icon-${icon.family}-${icon.name}-${icon.style}`
      },

      getCurrentIconIndex() {
        return this.state ? this.state.hits.findIndex((i) => i.objectID == this.iconObjectId) : 0
      },

      scrollToIcon(iconElement) {
        const element = document.querySelector(`#${iconElement}`)
        element.scrollIntoView()
      },

      toggleIcon(icon, iconTag, objectId) {
        this.state.sendEvent('click', icon, 'Icon Clicked')
        this.iconObjectId = objectId
        this.$emit('toggleIcon', icon, iconTag)
      },

      sluggifyStyle(style) {
        return sluggify(style)
      },

      closeIcon() {
        this.$emit('closeIcon')
      }
    }
  }
</script>
